import React from "react";
import Selector from "../../../Shared/Selector";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";

export function FilterOcReseted({
  mainGroup,
  filterOcReseted,
  setFilterOcReseted,
  action
}) {

  const filters = [
    { value: 'all', label: 'Todas' },
    { value: 'reseted', label: 'Reiniciadas' },
    { value: 'not_reseted', label: 'Não reiniciadas' }
  ];

  return action.indexOf("validar-documentos") !== -1 &&
  ["support", "backoffice"].indexOf(mainGroup) !== -1 && (
    <Grid
      item
      xs={12}
      sm={12}
      md={1}
      lg={1}
    >
      <Box>
        <h4>OCs Reiniciadas</h4>
        <Selector
          options={filters}
          placeholder="Selecione uma opção"
          data-cy="tabHeader-filterOcReseted-select"
          id="tabHeader-filterOcReseted-select"
          isClearable
          selected={filterOcReseted.value}
          value={filterOcReseted}
          onChange={setFilterOcReseted}
        />
      </Box>
    </Grid>
  )
}

const mapState = (state) => ({
  filterOcReseted: state.loadingOrders.filterOcReseted
});

const mapDispatch = (dispatch) => ({
  setFilterOcReseted: (payload) => dispatch.loadingOrders.setFilterOcReseted(payload)
});

export default connect(mapState, mapDispatch)(FilterOcReseted);
